import type { TransformerId } from '@finance/contracts';
import { registerTransformer, applyTransformer } from './transformer-registry';

export { registerTransformer, getTransformer } from './transformer-registry';

export type ValueTransformer = (value: unknown) => unknown;

export function applyInputTransform(value: unknown, transformerId?: TransformerId): unknown {
  if (!transformerId) return value;
  return applyTransformer(transformerId, value);
}

export function applyOutputTransform(value: unknown, transformerId?: TransformerId): unknown {
  if (!transformerId) return value;
  return applyTransformer(transformerId, value);
}

registerTransformer('trim' as TransformerId, (value) => {
  if (typeof value === 'string') return value.trim();
  return value;
});

registerTransformer('toLowerCase' as TransformerId, (value) => {
  if (typeof value === 'string') return value.toLowerCase();
  return value;
});

registerTransformer('toUpperCase' as TransformerId, (value) => {
  if (typeof value === 'string') return value.toUpperCase();
  return value;
});

registerTransformer('toNumber' as TransformerId, (value) => {
  if (typeof value === 'string' && value !== '') {
    const num = Number(value);
    return isNaN(num) ? value : num;
  }
  return value;
});

registerTransformer('toString' as TransformerId, (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
});

registerTransformer('toInteger' as TransformerId, (value) => {
  if (typeof value === 'string' && value !== '') {
    const num = parseInt(value, 10);
    return isNaN(num) ? value : num;
  }
  if (typeof value === 'number') {
    return Math.trunc(value);
  }
  return value;
});

registerTransformer('toBoolean' as TransformerId, (value) => {
  if (typeof value === 'string') {
    return value === 'true' || value === '1';
  }
  return Boolean(value);
});

registerTransformer('clampPercent' as TransformerId, (value) => {
  if (typeof value === 'number') {
    return Math.max(0, Math.min(100, value));
  }
  if (typeof value === 'string' && value !== '') {
    const num = Number(value);
    if (!isNaN(num)) return String(Math.max(0, Math.min(100, num)));
  }
  return value;
});

registerTransformer('toDecimal' as TransformerId, (value) => {
  if (value === '' || value === null || value === undefined) return undefined;
  return String(value);
});

registerTransformer('emptyToNull' as TransformerId, (value) => {
  if (value === '' || value === undefined) return null;
  return value;
});

registerTransformer('emptyToUndefined' as TransformerId, (value) => {
  if (value === '' || value === null) return undefined;
  return value;
});
